import { ConditionalLog, } from "./tools";

let openFetches = 0;
export function NumberOfTasksToWaitFor() { return openFetches; }

export function RegisterStartOfTask() {
    openFetches++;
}
export function RegisterEndOfTask() {
    if (openFetches <= 0)
        throw new Error("Tried to end an open fetch, but no fetches were pending?");
    openFetches--;
}

export function RedirectTo(href: string) {
    ConditionalLog.log("redirecting to:", href);
    RegisterStartOfTask(); //start but never end: this JS context is doomed, and the new page will have a new (and zero) openFetches count.
    location.href = href;
}

const underlyingFetch = fetch;
function counted_fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    RegisterStartOfTask();
    const response = underlyingFetch(input, init);
    return response.then(o => {
        RegisterEndOfTask();
        return o;
    }).catch(o => {
        RegisterEndOfTask();
        return o;
    });
}

const underlying_XMLHttpRequest_open = XMLHttpRequest.prototype.open;
function counted_XMLHttpRequest_open(this: XMLHttpRequest) {
        RegisterStartOfTask();
        let open = true;
        this.addEventListener("readystatechange", function () {
            if (this.readyState == 4 && open) {
                open = false;
                RegisterEndOfTask();
            }
        }, false);
        underlying_XMLHttpRequest_open.apply(this, arguments as any);
    }

export function ProxyHttpRequestFunctions() {
    (window as any).NumberOfTasksToWaitFor = NumberOfTasksToWaitFor;
    XMLHttpRequest.prototype.open = counted_XMLHttpRequest_open;
    (window as any).fetch = counted_fetch;
}

